import { createSlice } from '@reduxjs/toolkit'
import { service } from '../shared/_services/api_service'
import { setLoading } from './loader';
import { errorHandler, successHandler } from '../shared/_helper/responseHelper';

const initialState = {
  liveChapterData: [],
  totalliveChapter: 0,
  isOpenModal: false,
}

export const liveChapterSlice = createSlice({
  name: "liveChapter",
  initialState,
  reducers: {
    setliveChapterData(state, { payload }) {
      state.liveChapterData = payload.result
      state.totalliveChapter = payload.count
    },
    updateliveChapterData(state, { payload }) {
      const objIndex = state.liveChapterData.findIndex((obj) => obj._id === payload._id);
      if (objIndex >= 0) {
        state.liveChapterData[objIndex] = payload
      }
    },
    deleteliveChapterData(state, { payload }) {
      const objIndex = state.liveChapterData.findIndex((obj) => obj._id === payload);
      if (objIndex >= 0) {
        state.liveChapterData.splice(objIndex, 1)
      }
    },
    pushliveChapterData(state, { payload }) {
      state.liveChapterData.push(payload)
      state.totalliveChapter +=  1
    },

    isOpenModal(state, { payload }) {
      state.isOpenModal = payload
    },
    ModalToggle(state, { payload }) {
      state.isOpenModal = !state.isOpenModal
    },
  }
})

export const { setliveChapterData, updateliveChapterData, deleteliveChapterData, pushliveChapterData, isOpenModal,
  ModalToggle } = liveChapterSlice.actions;

export default liveChapterSlice.reducer;

export function getliveChapter(limit, offset, id) {
  return async function getliveChapterThunk(dispatch) {
    dispatch(setLoading(true))
    try {
      await service.getliveChapter(limit, offset, id).then(
        (response) => {
          dispatch(setLoading(false))
          dispatch(setliveChapterData(response.data))
        }, (error) => {
          dispatch(setLoading(false))
          errorHandler(error.response)
        }
      );
    } catch (err) {

    }
  }
}
export function addliveChapter(payload) {
  return async function addliveChapterThunk(dispatch) {
    dispatch(setLoading(true))
    try {
      await service.addliveChapter(payload).then(
        (response) => {
          dispatch(ModalToggle())
          dispatch(setLoading(false))
          dispatch(pushliveChapterData(response.data))
          successHandler('Added Successfully')
        }, (error) => {
          dispatch(setLoading(false))
          errorHandler(error.response)
        }
      );
    } catch (err) {

    }
  }
}
export function updateliveChapter(id, name) {
  return async function updateliveChapterThunk(dispatch) {
    dispatch(setLoading(true))
    try {
      await service.updateliveChapter(id, name).then(
        (response) => {
          dispatch(ModalToggle())
          dispatch(setLoading(false))
          dispatch(updateliveChapterData(response.data))
          successHandler('Updated Successfully')
        }, (error) => {
          dispatch(setLoading(false))
          errorHandler(error.response)
        }
      );
    } catch (err) {

    }
  }
}


export function deleteLiveChapter(id) {
  return async function deleteLiveChapterThunk(dispatch) {
    try {
      dispatch(setLoading(true))
      await service.deleteLiveChapter(id).then(
        (response) => {
          dispatch(deleteliveChapterData(id))
          dispatch(setLoading(false))
          successHandler('Deleted Successfully')
        }, (error) => {
          dispatch(setLoading(false))
          errorHandler(error.response)
        }
      );
    } catch (err) {

    }
  }
}



